const TYPE_PAYMENT = {
  FULL_PAYMENT: 'fullPayment',
  PARTIAL_PAYMENT: 'partialPayment'
};

exports.TYPE_PAYMENT = TYPE_PAYMENT;
